import CountryPageTemplate from './CountryPageTemplate';

export default function SlovakiaPage() {
  return <CountryPageTemplate countryKey="sk" />;
}